import { ENV_VARS } from '@/env';

import { API } from '../../api';
import { deprecate } from '../../utils/deprecate';
import { axiosInstance } from '../../utils/fetcher';

const isHBUser = ENV_VARS.REACT_APP_THEME === 'halliburton';
const CancelToken = axiosInstance.CancelToken;

let getSearchQuoteListEffectCancelToken = () => {};
export const getSearchQuoteListEffect = (data) => {
  getSearchQuoteListEffectCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getSearchQuoteListEffectCancelToken = c;
    }),
    data,
    method: 'post',
    url: `${API.SPOT_QUOTE_V2}/search`,
  });
};

let getShipmentListEffectCancelToken = () => {};
export const getShipmentListEffect = (data) => {
  getShipmentListEffectCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getShipmentListEffectCancelToken = c;
    }),
    method: 'get',
    params: data,
    url: `${API.SHIPMENT}/shipmentsearch`,
  });
};

let getShipmentDetailsCancelToken = () => {};
export const getShipmentDetailsEffect = (data) => {
  getShipmentDetailsCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getShipmentDetailsCancelToken = c;
    }),
    method: 'get',
    params: data,
    url: `${API.SHIPMENT}/GetShipment`,
  });
};

export const getShipmentStatusListEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SHIPMENT}/GetShipmentStatus`,
  });
};

export const getShipmentStatusListQuote = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SPOT_QUOTE_V2}/options/statuses`,
  });
};

export const SetSpotQuoteStatusAwardedEffect = (data) => {
  return axiosInstance.request({
    method: 'patch',
    params: data,
    url: `${API.SPOT_QUOTE}/SetSpotQuoteStatusAwarded`,
  });
};

export const getShipmentCargoTypesEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SHIPMENT}/GetShipmentCargo`,
  });
};

let getShipmentAppointmentTypesEffectCancelToken = () => {};
export const getShipmentAppointmentTypes = () => {
  getShipmentAppointmentTypesEffectCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getShipmentAppointmentTypesEffectCancelToken = c;
    }),
    method: 'get',
    url: `${API.SHIPMENT}/GetShipmentAppointmentype`,
  });
};

export const getShipmentCreatedBy = (params) => {
  const url = isHBUser ? `${API.SPOT_QUOTE}/GetQuoteCreatedByDetails` : `${API.SPOT_QUOTE_V2}/created-by-details`;

  return axiosInstance.request({
    method: 'get',
    params,
    url,
  });
};

export const getSpotQuoteHistory = (quoteKey) => {
  return axiosInstance.request({
    headers: { 'Content-Type': 'application/json' },
    method: 'get',
    params: { quoteKey },
    url: `${API.SPOT_QUOTE_V2}/history`,
  });
};

export const getVendorList = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetVendorSearch`,
  });
};

export const getShipmentPortCodes = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetPortCode`,
  });
};

export const getShipmentPortList = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.PRIMARY}/GetPortSearch`,
  });
};

let getShipmentStopTypesEffectCancelToken = () => {};
export const getShipmentStopTypes = () => {
  getShipmentStopTypesEffectCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getShipmentStopTypesEffectCancelToken = c;
    }),
    method: 'get',
    url: `${API.SHIPMENT}/GetShipmentStopType`,
  });
};

let getQuoteShipmentStopTypesEffectCancelToken = () => {};
export const getQuoteShipmentStopTypes = () => {
  getQuoteShipmentStopTypesEffectCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getQuoteShipmentStopTypesEffectCancelToken = c;
    }),
    method: 'get',
    url: `${API.SPOT_QUOTE_V2}/options/stop-types`,
  });
};

export const getIncortermListEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SHIPMENT}/GetIncoTerm`,
  });
};

export const gerFreeOnBoardEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SHIPMENT}/GetAllFreeOnBoard`,
  });
};

export const getCarrierListEffect = (params = {}) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.POV}/GetCarrier`,
  });
};

let getProductUOMListTypesEffectCancelToken = () => {};
export const getProductUOMListTypesEffect = () => {
  getProductUOMListTypesEffectCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getProductUOMListTypesEffectCancelToken = c;
    }),
    method: 'get',
    url: `${API.SHIPMENT}/GetProductUnitUom`,
  });
};

let getProductDimUomListEffectCancelToken = () => {};
export const getProductDimUomListEffect = () => {
  getProductDimUomListEffectCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getProductDimUomListEffectCancelToken = c;
    }),
    method: 'get',
    url: `${API.SHIPMENT}/GetProductDimUom`,
  });
};

let getQuoteProductDimUomListEffectCancelToken = () => {};
export const getQuoteProductDimUomListEffect = () => {
  getQuoteProductDimUomListEffectCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getQuoteProductDimUomListEffectCancelToken = c;
    }),
    method: 'get',
    url: `${API.SPOT_QUOTE_V2}/options/dim-uoms`,
  });
};

export const getProductsEffect = (params = {}) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetProductSearchbySingleRequest`,
  });
};

export const getRatingPreferenceEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SHIPMENT}/GetAllRatingPreferences`,
  });
};

export const getZipCodeDetailsEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetZipCodeDetails`,
  });
};

export const getServiceLevelEffect = (params = {}) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetShipmentServiceLevel`,
  });
};

let getShipperSearchEffectCancelToken = () => {};
export const getShipperSearchEffect = (params = {}) => {
  getShipperSearchEffectCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getShipperSearchEffectCancelToken = c;
    }),
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetShipperSearch`,
  });
};

let getConsigneeSearchEffectCancelToken = () => {};
export const getConsigneeSearchEffect = (params = {}) => {
  getConsigneeSearchEffectCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getConsigneeSearchEffectCancelToken = c;
    }),
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetConsigneeSearch`,
  });
};

export const generateShipmentNoEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GenerateShipmentNumber`,
  });
};

export const generateApprovalNoEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GenerateApprovalNumber`,
  });
};

export const getSportBidExpireTimeEffect = (params = {}) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetSpotBidExpirationTime`,
  });
};

export const getTimeZonesEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SHIPMENT}/GetTimeZone`,
  });
};

let locationSearchEffectCancelToken = () => {};
export const locationSearchEffect = (params = {}) => {
  locationSearchEffectCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      locationSearchEffectCancelToken = c;
    }),
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetLocationSearch`,
  });
};

export const deleteShipmentsEffect = (data) => {
  return axiosInstance.request({
    method: 'post',
    params: data,
    url: `${API.SHIPMENT}/DeleteShipment`,
  });
};

export const copyShipmentEffect = (data) => {
  return axiosInstance.request({
    method: 'post',
    params: data,
    url: `${API.SHIPMENT}/CopyShipment`,
  });
};

export const consolidateShipmentsEffect = (data) => {
  return axiosInstance.request({
    method: 'get',
    params: data,
    url: `${API.SHIPMENT}/ShipmentConsolidation`,
  });
};

export const updateShipmentStatusEffect = (data) => {
  return axiosInstance.request({
    data,
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.SHIPMENT}/ShipmentStatusChange`,
  });
};

export const createShipmentEffect = (data) => {
  return axiosInstance.request({
    data,
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.SHIPMENT}/CreateShipment`,
  });
};

export const shipmentSpotBidEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SHIPMENT}/SpotBidShipment`,
  });
};

export const shipmentAddBidderEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SHIPMENT}/SpotBidAddBidder`,
  });
};

export const getShipmentRateShopListEffect = (data) => {
  // TODO: double check
  return axiosInstance.post(`${API.BASE_ORIGIN}/rateengine/rateall`, data);
};

export const getShipmentExportDetails = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SHIPMENT}/GetShipmentExportDetailsPost`,
  });
};

export const shipmentEndSpotBidEffect = (params) => {
  return axiosInstance.request({
    method: 'post',
    params,
    url: `${API.SHIPMENT}/EndShipmentSpotBid`,
  });
};

export const getShipmentDocumentListEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetAllShipmentDocuments`,
  });
};

export const shipmentFileUploadEffect = (data) => {
  return axiosInstance.request({
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'post',
    url: `${API.SHIPMENT}/UploadShipmentDocument`,
  });
};

export const shipmentFileDeleteEffect = (params) => {
  return axiosInstance.request({
    method: 'delete',
    params,
    url: `${API.SHIPMENT}/DeleteShipmentDocument`,
  });
};

export const shipmentFileUpdateEffect = (data) => {
  return axiosInstance.request({
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'post',
    url: `${API.SHIPMENT}/UpdateShipmentDocument`,
  });
};

export const getShipmentDefaultAccessorialsForCustomerEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetShipmentAccessorialsForCustomer`,
  });
};

export const getShipmentTenderEmailEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetTenderEmailAddress`,
  });
};

export const shipmentTenderProcessEffect = (params) => {
  return axiosInstance.request({
    method: 'post',
    params,
    url: `${API.SHIPMENT}/ShipmentTenderProcess`,
  });
};

export const getShipmentSpotBidDataEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetSpotBidCarrierListForShipment`,
  });
};

export const shipmentPartialSaveEffect = ({ URL, ...data }) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SHIPMENT}/${URL}`,
  });
};

export const shipmentPartialSaveNotesEffect = (params) => {
  return axiosInstance.request({
    method: 'post',
    params,
    url: `${API.SHIPMENT}/ShipmentPartialSaveNotes`,
  });
};

export const shipmentCalculateMileageEffect = (params) => {
  return axiosInstance.request({
    method: 'post',
    params,
    url: `${API.SHIPMENT}/CalculateShipmentMileage`,
  });
};

export const getPostalSearchEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetPostalSearch`,
  });
};

export const saveRateShopResultEffect = (data) => {
  return axiosInstance.request({
    data: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.SHIPMENT}/AddRateShopData`,
  });
};

let getShipmentBolCancelToken = () => {};
export const getShipmentBolEffect = (data) => {
  getShipmentBolCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getShipmentBolCancelToken = c;
    }),
    method: 'post',
    params: data,
    url: `${API.SHIPMENT}/GetBOL`,
  });
};

let getShipmentCommercialInvoiceCancelToken = () => {};
export const getShipmentCommercialInvoiceEffect = (data) => {
  getShipmentCommercialInvoiceCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getShipmentCommercialInvoiceCancelToken = c;
    }),
    method: 'post',
    params: data,
    url: `${API.SHIPMENT}/GetCommercialInvoice`,
  });
};

let getShipmentPackingListCancelToken = () => {};
export const getShipmentPackingListEffect = (data) => {
  getShipmentPackingListCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getShipmentPackingListCancelToken = c;
    }),
    method: 'post',
    params: data,
    url: `${API.SHIPMENT}/GetPackingList`,
  });
};

let saveShipmentCommercialInvoiceCancelToken = () => {};
export const saveShipmentCommercialInvoiceEffect = (data) => {
  saveShipmentCommercialInvoiceCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      saveShipmentCommercialInvoiceCancelToken = c;
    }),
    data,
    method: 'post',
    url: `${API.SHIPMENT}/SaveCommercialInvoice`,
  });
};

export const getShipmentCustomerRoutingsSettingsEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/customerroutingsettings`,
  });
};

export const saveShipmentAddressBookEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SHIPMENT}/SaveAddressBook`,
  });
};

export const deleteShipmentAddressBookEffect = deprecate(
  (params) => {
    return axiosInstance.request({
      method: 'delete',
      params,
      url: `${API.SHIPMENT}/DeleteAddressBookRecord`,
    });
  },
  {
    message: 'use useDeleteAddress hook instead',
  },
);

export const saveShipmentProductEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SHIPMENT}/AddProduct`,
  });
};

export const saveShipmentRateShopFiltersEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SHIPMENT}/ShipmentPartialSaveRatingDetails`,
  });
};

export const updateShipmentStatusToRatedEffect = (params) => {
  return axiosInstance.request({
    method: 'post',
    params,
    url: `${API.SHIPMENT}/UpdateStatusChangeToRated`,
  });
};

export const getShipmentItrackEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetShipmentITrackData`,
  });
};

export const sendMailShipmentDocumentEffect = ({ data, params }) => {
  return axiosInstance.request({
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'post',
    params,
    url: `${API.SHIPMENT}/SendMailForDocument`,
  });
};

export const checkAddressBookIsExistEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/CheckAddressbookResult`,
  });
};

export const saveShipmentItrackEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SHIPMENT}/AddShipmentITrackData`,
  });
};

export const getShipmentNotificationRoutingEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetShipmentNotificationRouting`,
  });
};

export const getShipmentNotificationDistributorsEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetShipmentDistributionList`,
  });
};

export const createShipmentNotificationDistributorsEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SHIPMENT}/CreateDistributionList`,
  });
};

export const updateShipmentNotificationDistributorsEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SHIPMENT}/UpdateDistributionList`,
  });
};

export const deleteShipmentNotificationDistributorsEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SHIPMENT}/DeleteDistributionList`,
  });
};

export const createShipmentNotificationRoutingEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SHIPMENT}/CreateNotificationRouting`,
  });
};

export const updateShipmentNotificationRoutingEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SHIPMENT}/UpdateNotificationRouting`,
  });
};

export const deleteShipmentNotificationRoutingEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SHIPMENT}/DeleteNotificationRouting`,
  });
};

export const getShipmentCustomerAddressBookSearchEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetAddressbookSearch`,
  });
};

export const getShipmentAllAccessorialsEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetShipmentAccessorials`,
  });
};

export const createShipmentQuoteEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SHIPMENT}/CreateQuote/V1`,
  });
};

export const saveShipmentAccessorialsPartialEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SHIPMENT}/UpdatePartialShipmentAccessorialDetails`,
  });
};

export const saveShipmentTaxesPartialEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SHIPMENT}/UpdatePartialShipmentTaxDetails`,
  });
};

export const createShipmentFromQuoteEffect = (params) => {
  return axiosInstance.request({
    method: 'post',
    params,
    url: `${API.SHIPMENT}/CreateShipmentFromQuote`,
  });
};

export const getMilageByStopsEffect = (data) => {
  return axiosInstance.request({
    baseURL: `${ENV_VARS.REACT_APP_ORIGIN_API}/api/pcmiler/getstopmileage`,
    data,
    method: 'post',
  });
};

export const getBrachAccountNumbersEffect = (params = {}) => {
  return axiosInstance.request({
    method: 'POST',
    params,
    url: `${API.SHIPMENT}/GetAccountNumber`,
  });
};

export const getParcelExpressRatesEffect = (data = {}) => {
  if (data?.vendorService === true) {
    return axiosInstance.request({
      data,
      method: 'POST',
      url: `${API.POV}/GetVendorSmallParcelRate`,
    });
  }

  return axiosInstance.request({
    data,
    method: 'POST',
    url: `${API.SHIPMENT}/GetSmallParcelRate`,
  });
};

export const createParcelExpressShipmentEffect = (data = {}) => {
  if (data?.vendorService === true) {
    return axiosInstance.request({
      data,
      method: 'POST',
      url: `${API.POV}/CreateVendorSmallParcelShipmentLabel`,
    });
  }

  return axiosInstance.request({
    data,
    method: 'POST',
    url: `${API.SHIPMENT}/CreateSmallParcelShipmentLabel`,
  });
};

export const validateAndGetApproversEffect = (params = {}) => {
  return axiosInstance.request({
    method: 'post',
    params,
    url: `${API.SHIPMENT}/ShipmentApprovalProcess`,
  });
};

export const createChildShipmentEffect = (params = {}) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/ShipmentChildShipment`,
  });
};

export const sendShipmentApprovalEffect = (data = {}) => {
  return axiosInstance.request({
    data,
    method: 'POST',
    url: `${API.SHIPMENT}/ApprovalProcess`,
  });
};

export const shipmentAddRateEntryEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SHIPMENT}/AddShipmentRateEntry`,
  });
};

export const shipmentValidateRateEntryEffect = (params) => {
  return axiosInstance.request({
    method: 'post',
    params,
    url: `${API.SHIPMENT}/ValidateShipmentRateEntry`,
  });
};

export const shipmentRemoveRateEntryEffect = (params) => {
  return axiosInstance.request({
    method: 'post',
    params,
    url: `${API.SHIPMENT}/DeleteShipmentRateEntry`,
  });
};

export const getMasterChildShipmentDetailsEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetMasterChildInfoDetails`,
  });
};

export const generateAutomaticProNumber = (data) =>
  axiosInstance.request({
    data,
    method: 'POST',
    url: `${API.SHIPMENT}/CustomerProNumberAssignment`,
  });

export const shipmentUpdateRateEntryEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SHIPMENT}/UpdateShipmentRateEntry`,
  });
};

export const getProductDetailsByCodeEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetProductSearchbyCodeExactMatch`,
  });
};

export const createPartialShipmentEffect = (data) => {
  return axiosInstance.request({
    data,
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.SHIPMENT}/ShipmentPartialSaveProcess`,
  });
};

export const convertPartialToShipmentEffect = (data) => {
  return axiosInstance.request({
    data,
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.SHIPMENT}/UpdatePartialToNewShipment`,
  });
};

export const getShipmentBranchAddressEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetShipmentBranchAddress`,
  });
};

export const getShipmentsStopsEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetShipmentStopsById`,
  });
};

export const getParcelExpressDashboardDataEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetParcelShipmentDashboard`,
  });
};

export const getShipmentTableViewColumn = (GridName = 'Shipment') => {
  return axiosInstance.request({
    method: 'get',
    params: { GridName },
    url: `${API.SECURITY}/GetGridColumnOptions`,
  });
};

export const saveShipmentTableViewColumn = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SECURITY}/SaveGridColumnOption`,
  });
};

export const getShipmentProductListEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetShipmentProductDetailsWithTotalCount`,
  });
};

export const getShipmentProductFullListEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetShipmentProductDetails`,
  });
};

export const updateShipmentProductFBCLassEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SHIPMENT}/UpdateShipmentFreightClass`,
  });
};

export const shipmentNmfcCalculateEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/NMFCFreightCalulation`,
  });
};

export const getAPIRateShopByWrapperAPIEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SHIPMENT}/GetAPIRateshop`,
  });
};

let getCarriersForCollectShipmentEffectCancelToken = () => {};
export const getCarriersForCollectShipmentEffect = (params = {}) => {
  getCarriersForCollectShipmentEffectCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getCarriersForCollectShipmentEffectCancelToken = c;
    }),
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetShipmentCollectCarrier`,
  });
};

export const updateShipmentBOLCarrierEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SHIPMENT}/UpdateBOLCarrierSave`,
  });
};

export const getShipmentAdvancePlanningNoticeEmailsEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetAdvancePlanningEmailAddress`,
  });
};

export const sendShipmentAdvancePlanningNoticeEmailEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SHIPMENT}/ShipmentAdvancePlanningProcess`,
  });
};

export const getPalletPackageTypesEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SHIPMENT}/GetShipmentPalletPackageType`,
  });
};

// todo refactor it (SPOT QUOTE STATE)

export const getSpotQuoteBiddersEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SPOT_QUOTE_V2}/carriers/bidding-details`,
  });
};

export const searchSpotQuoteBiddersEffect = (params) => {
  const url = isHBUser
    ? `${API.SPOT_QUOTE}/SearchAllRoutingGuideCarriers`
    : `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/carriers/search`;

  return axiosInstance.request({
    method: 'get',
    params,
    url,
  });
};

export const addQuoteBiddersEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'patch',
    url: `${API.SPOT_QUOTE_V2}/carriers/bidding-carrier`,
  });
};

export const addSpotQuoteBiddersEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'patch',
    url: `${API.SPOT_QUOTE_V2}/carriers/spot-bid`,
  });
};

export const deleteSpotQuoteBiddersEffect = (params) => {
  return axiosInstance.request({
    method: 'delete',
    params,
    url: `${API.SPOT_QUOTE_V2}/carriers/bidding-carrier`,
  });
};

export const setSpotQuoteStatusAwardedEffect = (params) => {
  return axiosInstance.request({
    method: 'patch',
    params,
    url: `${API.SPOT_QUOTE_V2}/statuses/set-awarded`,
  });
};

export const deleteShipmentTenderProcessEffect = (params) => {
  return axiosInstance.request({
    method: 'post',
    params,
    url: `${API.SHIPMENT}/DeleteShipmentTenderRateEntryData`,
  });
};

export const getSpotQuoteCollaboratorsEffect = (spotQuoteId) => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SPOT_QUOTE_V2}/collaborators/${spotQuoteId}`,
  });
};

export const addSpotQuoteCollaboratorsEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'patch',
    url: `${API.SPOT_QUOTE_V2}/collaborators`,
  });
};

export const deleteSpotQuoteCollaboratorsEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'delete',
    url: `${API.SPOT_QUOTE_V2}/collaborators`,
  });
};

export const getShipperAccountNumberListEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetShipperAccountNumber`,
  });
};

export const getDutyAndTaxNumberListEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetTaxDuityNumber`,
  });
};

export const getAccountNumberInfo = (accountNumber) => {
  return axiosInstance.request({
    method: 'get',
    params: { accountNumber },
    url: `${API.SHIPMENT}/GetAccountInfo`,
  });
};

export const getQuoteAwardReasonsEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SPOT_QUOTE_V2}/options/award-reasons`,
  });
};

export const getShipmentVendorPortSearch = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetVendorPortSearch`,
  });
};

export const getCargoSpecificAccessorialsEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetShipmentCargoTypeAccessorials`,
  });
};

export const checkAddressExistEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SHIPMENT}/CheckAddressExist`,
  });
};
